import {
  Component,
  Element,
  Event,
  EventEmitter,
  h,
  Host,
  JSX,
  State,
} from "@stencil/core";
import { componentsOnReady } from "@phn/utility/ready";
import { Timeout } from "@phn/utility/timeout";
import { navContentStore } from "@phn/state/nav-content-store";
import { getConfig } from "@phn/utility/helper";
import { navStateStore } from "@phn/state/nav-state-store";
import { logout } from "@phn/services/user-service";
import {
  dispatchAuthEvent,
  PHN_AUTH_EVENT,
} from "@phn/services/auth-event.service";
import Links from "./account-drawer-links";
import Login from "./account-drawer-login";

@Component({
  tag: "phn-nd-account-drawer",
  styleUrl: "account-drawer.scss",
  scoped: true,
})
export class AccountDrawer {
  @State() showSkeleton = !navStateStore.state.accountLoaded;

  @Element() el!: HTMLPhnNdAccountDrawerElement;

  @Event({ composed: true, bubbles: true, cancelable: true })
  phnLogout!: EventEmitter<void>;

  private eventPreventedTimeout = new Timeout(0);

  private async waitForComponentsToLoad() {
    await componentsOnReady(this.el, new Timeout(5000));
    this.showSkeleton = false;
  }

  componentDidRender() {
    navStateStore.state.accountLoaded = true;
  }

  handleLogout() {
    const config = getConfig(navStateStore.state.env);

    const phnLogout = this.phnLogout.emit();

    this.eventPreventedTimeout.set(() => {
      if (phnLogout.defaultPrevented) {
        dispatchAuthEvent({
          eventType: PHN_AUTH_EVENT.LOGOUT_DEFAULT_PREVENTED,
        });
        return;
      }

      logout(config);

      return;
    });
  }

  componentWillLoad(): void {
    this.waitForComponentsToLoad();
  }

  render(): JSX.Element | null {
    const { account } = navContentStore.state;

    if (!account) return null;

    return (
      <Host class={this.showSkeleton ? "skeleton" : ""}>
        <div class="phn-flex-col phn-justify-around">
          <Login content={account} showSkeleton={this.showSkeleton} />
          <Links
            content={account}
            onLogoutClick={() => this.handleLogout()}
            showSkeleton={this.showSkeleton}
          />
        </div>
      </Host>
    );
  }
}
